export const TRACK_EVENT_NAMES = {
  ADD_TO_WISHLIST: 'add_to_wishlist',
  ADD_TO_CART: 'add_to_cart',
  BALANCE_PAYMENT_SPLIT: 'balance_payment_split',
  BALANCE_PAYMENT_VALIDATION: 'balance_payment_validation',
  BEGIN_CHECKOUT: 'begin_checkout',
  CLICK_ACCOMMODATION: 'click_accommodation',
  CLICK_ACCOMMODATION_LAYER: 'click_accommodation_layer',
  CLICK_ACTIVITIES: 'click_activities',
  CLICK_ACTIVITIES_LAYER: 'click_activities_layer',
  CLICK_ACTIVITIES_SERVICES: 'click_activities_services',
  CLICK_ANCHOR: 'click_anchor',
  CLICK_BOTTOM_BAR: 'click_bottom_bar',
  CLICK_BREADCRUMB: 'click_breadcrumb',
  CLICK_CA_DASHBOARD: 'click_dashboard',
  CLICK_CA_GM: 'click_great_members',
  CLICK_CA_IMMERSIVE: 'click_immersive',
  CLICK_CA_LOGOUT: 'click_logout',
  CLICK_CA_NAV: 'click_member_nav',
  CLICK_PRICE_SUMMARY: 'click_price_summary',
  CLICK_CA_REMOTE: 'click_remote',
  CLICK_CA_SPONSORPHIP: 'click_sponsorship',
  CLICK_CA_STAY_DETAILS: 'click_stays_details',
  CLICK_CA_TRANSPORT: 'click_ca_my_transport',
  CLICK_CART: 'click_cart',
  CLICK_CONFIRMATION: 'click_confirmation',
  CLICK_ERROR: 'click_error',
  CLICK_FOOTER: 'click_footer',
  CLICK_HEADER: 'click_header',
  CLICK_INFOBANNER: 'click_infobanner',
  CLICK_NEWSLETTER: 'click_newsletter',
  CLICK_OPTION_RENEWAL: 'click_option_renewal',
  CLICK_PARTICIPANTS: 'click_participants',
  CLICK_PAYMENT: 'click_payment',
  CLICK_PROFILE: 'click_profile',
  CLICK_RECEIPT_TICKET: 'click_receipt_ticket',
  CLICK_SUMMARY: 'click_summary',
  CLICK_TRANSPORT: 'click_transport',
  CLICK_TRANSPORT_LAYER: 'click_transport_layer',
  CLICK_TRAVEL_PLANS: 'click_travel_plans',
  CLICK_UPSELL: 'click_upsell',
  DISPLAY_OPTION: 'display_option',
  ERROR: 'error',
  FORM_ERROR: 'form_error',
  OPTION_HELD: 'option_held',
  PAGE_VIEW: 'page_view',
  PURCHASE: 'purchase',
  UPSELL_TRANSACTION: 'upsell_transaction',
  CLICK_PREBOOKING_FILTERS: 'click_prebooking_filters',
  CLICK_PREBOOKING_FORM_PREREG: 'click_pre_registration',
  CLICK_SHOPPING_TOUR_QUOTE: 'click_request_quote',
  CLICK_SHOPPING_TOUR_CONFIRMATION: 'shopping_tour_confirmation',
  CLICK_NEW_PROPOSALS: 'click_new_proposals',
};

export const TRACK_PAGE_NAMES = {
  CA_BALANCE_SPLIT_PAYMENT_CONFIRMATION: 'ca_balance_split_payment_confirmation',
  CA_BALANCE_FULL_PAYMENT_CONFIRMATION: 'ca_balance_full_payment_confirmation',
  CA_BANKING: 'ca_banking',
  CA_GREAT_MEMBERS: 'ca_great_members',
  CA_HOME: 'ca_homepage',
  CA_LAYER_ACCOMMODATIONS: 'ca_accommodation_layer',
  CA_LAYER_ACTIVITIES: 'ca_activities_layer',
  CA_LAYER_CHILDCARE: 'ca_childcare_layer',
  CA_LAYER_ESF: 'ca_esf_layer',
  CA_LAYER_INSURANCE: 'ca_insurance_layer',
  CA_PAYMENT_CONFIRMATION: 'ca_payment_confirmation',
  CA_LAYER_JOYVIEW: 'ca_joyview_layer',
  CA_LAYER_RENTALS: 'ca_activities_layer_ski',
  CA_LAYER_TEAM: 'ca_go_team_layer',
  CA_LAYER_TRANSFER: 'ca_transfer_layer',
  CA_LAYER_UPSELL_ROOM: 'ca_upsell_room_layer',
  CA_LAYER_VOUCHERS: 'ca_vouchers_layer',
  CA_NEWSLETTER: 'ca_newsletter',
  CA_NEWSLETTER_SUBSCRIPTION_CONFIRMATION: 'ca_newsletter_subscription_confirmation',
  CA_NEWSLETTER_UNSUBSCRIPTION_CONFIRMATION: 'ca_newsletter_unsubscription_confirmation',
  CA_OPTION_PAYMENT_CONFIRMATION: 'ca_option_payment_confirmation',
  CA_PROFILE: 'ca_my_profile',
  CA_SPONSORSHIP: 'ca_sponsorship',
  CA_STAY_FUTURE: 'ca_future_stay_details',
  CA_STAY_OPTION: 'ca_future_stay_details_option',
  CA_STAY_PAST: 'ca_past_stay_details',
  CA_STAYS: 'ca_my_stays',
  CA_TRAVEL_PLANS: 'ca_travel_plans',
  CA_UPSELL_PAYMENT_CONFIRMATION: 'ca_upsell_payment_confirmation',
  BE_ACCOMMODATION: 'be_accommodation',
  BE_TRANSPORT: 'be_transport',
  BE_SERVICES: 'be_services',
  BE_ACTIVITIES: 'be_activities',
  BE_PARTICIPANTS: 'be_participants',
  BE_SUMMARY: 'be_summary',
  BE_BANKING: 'be_banking',
  BE_LAYER_ACCOMMODATION: 'be_accommodation_layer',
  BE_LAYER_ACTIVITIES: 'be_activities_layer',
  BE_LAYER_SKI_ACTIVITIES: 'be_activities_layer_ski',
  BE_LAYER_TRANSPORT: 'be_transport_layer',
  ERROR_404: 'error_not_found',
  ERROR_500: '500_internal_servor_error',
  BE_CONFIRMATION: 'be_confirmation',
  PREBOOKING_FORM: 'prebookingform',
  PREBOOKING_FORM_CONFIRMATION: 'prebookingform_confirmation',
  SHOPPING_TOUR_CONFIRMATION: 'shopping_tour_confirmation',
};

export const TRACK_SITE_SECTIONS = {
  BE: 'booking_engine',
  CA: 'customer_account',
  ERROR: 'error',
  SHOPPING: 'shopping',
  PREBOOKING_FORM: 'shopping_prebooking',
};

export const TRACK_LOGGED_STATUS = {
  FULL: 'full_logged',
  NOT: 'not_logged',
  QUICK: 'quick_logged',
};

export const CALLMEBACK_EVENT = {
  whatsapp: 'whatsapp',
  phone: 'click_to_call',
};
export const EVENT_CLICK = {
  faq: 'faq',
  storeLocator: 'store_locator',
  callMeBack: 'whatsapp',
  mail: 'newsletter',
};

export const EVENT_GA = 'eventGA';
export const VIRTUAL_PAGE_LOAD = 'virtualPageLoadingDataLayer';

export const GA_DEFAULT_PAYLOAD = {
  event: EVENT_GA,
  valueGA: 0,
  nonInteraction: 0,
};

export const BE = 'Booking Engine';
export const BE_OPTION_CONFIRMATION = 'be_option_confirmation';
export const BE_OPTION_ERROR = 'BE_option_error';
export const BE_TRACKING = 'trackingBE';
export const CA_TRACKING = 'trackingCA';
export const BE_MORE_ACCOMMODATIONS = 'BE_moreRooms';
export const BE_MODIFY_TRANSPORT = 'BE_modifyTransport';
export const BE_MODIFY_TRANSPORT_ERROR = 'BE_modifyTransportError';
export const CONNECTION_STATUS_LOGGED = 'alreadyLogged';
export const CONNECTION_STATUS_QUICK_LOGGED = 'quickLogged';
export const CONNECTION_STATUS_NOT_LOGGED = 'notLogged';

export const PLE = 'PLE';
export const PLE_OPTION = 'PLE_option';
export const PLE_QUICK = 'PLE_quick';
export const PLE_QUICK_OPTION = 'PLE_quick_option';

export const PLE_TRACKING = 'trackingPLE';

export const SEARCH_LABEL_GA_MAP = {
  activity: 'activities',
  area: 'destination',
  country: 'destination',
  edito: 'editorial',
  none: 'searchCTA',
  resort: 'village',
};

export const SHOPPING_FAVORITE_PRODUCTS = 'SHOP_favoriteProductList';
export const SHOPPING_REMOTE_FAVORITE_PRODUCTS = 'SHOP_remoteFavoriteProductList';
export const SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX = 3;
export const SHOPPING_LAST_VISITED_PRODUCTS = 'SHOP_lastVisitedProducts';
export const SHOPPING_LAST_VISITED_PRODUCTS_NUMBER = 10;
export const SHOPPING_TRACKING = 'trackingSHOP';

export const SUMMER_DATE_START = 501;
export const SUMMER_DATE_END = 1102;

export const STATIC_PAGE_TYPES = {
  BE: 'bookingEngine',
  ERROR: 'ErrorPage',
  PLE: 'ple',
  PLE_PAYMENT_CONFIRMATION: 'ple-payment-confirmation',
  SHOPPING_HOME: 'home',
  SHOPPING_NEWSLETTER: 'newsletter',
  SHOPPING_PREBOOKING: 'prebooking',
  SHOPPING_SEARCH: 'search',
  SHOPPING_SITEPLAN: 'siteplan',
  SHOPPING_QUICKSEARCH_UNAVALIABILITY: 'shopping_quickSearch_unavailability',
  PREBOOKING_FORM: 'prebooking-form',
};

export const WEB_CALLBACK_OPEN = 'webCallBack';
export const WEB_CALLBACK_SUBMIT = 'webCallBack_validate';

export const MEETING_EVENT = {
  REQUEST: 'requestForm',
  SEND_REQUEST_SUCCESS: 'CTASendRequest',
  SEND_REQUEST_ERROR: 'CTASendRequest_error',
};

export const OFFER_PUSH = {
  ACTION: 'push_content_offers',
};

export const OPTION_ACTIONS = {
  CONTINUE: 'continue',
  DETAILS: 'details',
};

export const VOUCHER_CODE = 'voucherCode';
export const VOUCHER_DISCOUNT = 'voucherDiscount';

export const DIDOMI_VENDOR_CONSENT_COOKIE = 'didomiVendorsConsent';

export const CHILDCARE_TRACKING = {
  ADD_CHILDCARE: 'add_childcare',
  ADD_CHILDCARE_POPIN: 'add_popin_childcare',
  REMOVE_CHILDCARE: 'remove_childcare',
  ERROR_UNKNOWN_CHILDCARE: 'error_unknown_childcare',
};
